import { Box, Text } from '@chakra-ui/react';

/**
 * Empty basket state component
 * Displays when the basket has no items
 */
const EmptyBasket = (): JSX.Element => (
  <Box padding={6} alignItems="center">
    <Text textAlign="center">Empty basket</Text>
  </Box>
);

export default EmptyBasket;
